import { createRouter, createWebHistory } from 'vue-router';

export const AppRouter = createRouter({
  history: createWebHistory(),
  routes: [
    // Redirect to main route if route not found
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
});
